export type CitationPart = { text: string; number?: number }

/** Only numbered references backed by the server's evidence list become buttons. */
export function citationParts(text: string, count: number): CitationPart[] {
  const output: CitationPart[] = []
  const matches = text.matchAll(/\[([\d\s,，、]+)\]/g)
  let position = 0
  for (const match of matches) {
    const numbers = match[1]!.split(/[,，、]/).map(value => Number(value.trim()))
    if (!numbers.every(value => Number.isInteger(value) && value >= 1 && value <= count)) continue
    if (match.index! > position) output.push({ text: text.slice(position, match.index) })
    numbers.forEach(number => output.push({ text: `[${number}]`, number }))
    position = match.index! + match[0].length
  }
  if (position < text.length) output.push({ text: text.slice(position) })
  return output
}
